import React from 'react';
import Zubereitung from './Zubereitung';

const FORM_INVALID_STATE = 1;


class ZubereitungenBlock extends  React.Component {
    constructor(props) {
      super(props);

      this.state = this.props;
      
      this.handleZubereitungElementChange = this.handleZubereitungElementChange.bind(this);
      this.addZubereitung = this.addZubereitung.bind(this);
    }
    
    handleZubereitungElementChange(dataContainer) {
      let buffer = null;
      if(dataContainer.deleteElement) {
        buffer = this.state.preparations;
        delete buffer[dataContainer.keyzc];
        this.setState({  preparations: buffer });

      } else {
        switch(dataContainer.element) {
            case 'zubereitung':
              buffer = this.state.preparations;
              buffer[dataContainer.keyzc].zubereitung = dataContainer.wert;
              this.setState({  preparations: buffer });
            break;
          
            case 'schritt':
              buffer = this.state.preparations;
              buffer[dataContainer.keyzc].schritt = dataContainer.wert;
              this.setState({  preparations: buffer });
            break;
          default:
          break;
          }
      }
      
      this.props.onPreparationsChange(this.state.preparations);
     
    }
    addZubereitung(event) {
      event.preventDefault();
      let buffer = null;
      const   NeueZubereitung = {};
              NeueZubereitung.schritt = parseInt(this.state.preparations.length,10 )+1;
              NeueZubereitung.zubereitung = '';
              buffer = this.state.preparations;
              buffer.push(NeueZubereitung);
              this.setState({  preparations: buffer });
              this.props.onPreparationsChange(this.state.preparations);
              
    }
    render() {
      let _this = this;
      let preparationsValid =  ((this.props.preparationsIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
     return (
       
        
        <div className="Component Zutaten">
          <section className="tableIngredients">
           <h4 className="label">Zubereitungen</h4>
           <ul className="steps">
           {this.state.preparations.map(function(zubereitung, index){
                    return <Zubereitung key={index} keyzc={index} zubereitungcontainer={zubereitung} onZubereitungElementChange={_this.handleZubereitungElementChange} />;
                  })}
            </ul>
           <a className="add" href="#addZubereitung" onClick={this.addZubereitung}><img className='add_icon' src="/images//i_addRow.svg" alt="Weitere Zubereitung" />  Weitere Zubereitung</a>

           <label className={preparationsValid}>  
                <span className="field-message">Bitte Mindestens einen Zubereitungsschritt eingeben</span>
            </label>
            </section>
        </div>
           
      );
    }
  }

  export default ZubereitungenBlock;


// WEBPACK FOOTER //
// ./src/ZubereitungBlock.js